const RM_PLUS_HOSTS = [
  "rmplus.rightmove.co.uk",
  "rmplusportal.rightmove.co.uk",
];

const PUBLIC_RIGHTMOVE_PROPERTY_URL = "https://www.rightmove.co.uk/properties";

export const rmplusToPublicUrl = (listingUrl?: string): string | null => {
  if (!listingUrl) return null;

  const isRmPlusLink = RM_PLUS_HOSTS.some(host => listingUrl.includes(host));
  if (!isRmPlusLink) return null;

  const propertyIdMatch = listingUrl.match(/propertyId=(\d+)/);
  if (!propertyIdMatch) return null;

  return `${PUBLIC_RIGHTMOVE_PROPERTY_URL}/${propertyIdMatch[1]}`;
};
